<template>
  <section class=" p-0 w-100  bg-light mt-2 mb-2 shadow "
           style="min-height: 50px; background: url('image/slider0.jpg') top center fixed; background-size: cover;  ">
    <section class="row pt-2 pb-2 m-0">
      <section class="col-12 text-center row mx-auto justify-content-around m-0 p-0">
        <div class="col-3 mb-1 m-0 p-0">
          <section class="rounded rounded-circle bg-dark text-light text-center mx-auto counter "
                   style="width:100px;
    height:100px;line-height:100px;font-size:50px">
            24
          </section>
          <section class="text-center mx-auto text-light">
            ساعته
          </section>
        </div>
        <div class="col-3 mb-1 m-0 p-0">
          <section class="rounded rounded-circle bg-dark text-light text-center mx-auto counter"
                   style="width:100px;
    height:100px;line-height:100px;font-size:50px">
            7
          </section>
          <section class="text-center mx-auto text-light">
            روز هفته
          </section>
        </div>
        <div class="col-3 mb-1 m-0 p-0">
          <section class="rounded rounded-circle bg-dark text-light text-center mx-auto counter"
                   style="width:100px;
    height:100px;line-height:100px;font-size:50px">
            365
          </section>
          <section class="text-center mx-auto text-light">
            بدون تعطیلی
          </section>
        </div>
      </section>
    </section>

  </section>

</template>

<script>
export default {
  name: "Counters"
}
</script>

<style scoped>

</style>